import { PageHeader } from '../../../shared/components/PageHeader';
import { sectionTrail } from '../../../shared/components/section-trail';
import { ServiceItemsPage } from '../features/service-items/pages/ServiceItemsPage';

/** The Maintenance nav section: what trucks are serviced for, how often, and which truck classes each item applies to. */
export function MaintenancePage() {
  return (
    <>
      <PageHeader breadcrumbs={sectionTrail('maintenance')} title="Maintenance" description="What each truck is serviced for, and how often." />
      <ServiceItemsPage />
    </>
  );
}
